import { Pipe, PipeTransform } from '@angular/core';
import * as numeral from 'numeral';

@Pipe({
  name: 'formatNumber',
})
export class FormatNumberPipe implements PipeTransform {
  transform(value: string, ...args) {
    return numeral(value).format((args && args[0]) || '0a');
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-number/format-number.ts